import styles from '../styles/heroBanner.module.scss';
import hero from '../assets/hero.jpg';

export default function HeroBanner({
    title = "Join Us",
    subtitle = (
        <>
            Explore exciting career opportunities with Horbury Group.
            <br />
            Join a team committed to delivering excellence across the construction industry.
        </>
    ),
    subtitle2 = "",
    background = hero,
    titleFontSize = "4rem",
    subtitleFontSize = "1.35rem"
}) {

    return (

        <section className={styles.hero} style={{ backgroundImage: `url(${background})` }}>

            <div className={styles.overlay}>

                <div className={styles.content}>

                    <h1 className={styles.title} style={{ fontSize: `${titleFontSize}` }}>
                        {title}
                    </h1>
                    {subtitle && (
                    <p className={styles.description} style={{ fontSize: `${subtitleFontSize}` }}>
                        {subtitle}
                    </p>
                )}
                {subtitle2 && (
                    <p className={styles.description} style={{ fontSize: `${subtitleFontSize}` }}>
                        {subtitle2}
                    </p>
                )}    

                </div>

            </div>

        </section>

    );

}